import { erpAxios } from '..';

const editRacuni = async (data) => {
  const res = await erpAxios.post(`/racuni/editMultiple`, data);
  return res;
};

export default editRacuni;
